import {Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MenuItemGroup, Store} from '../../models/store';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-menu-group-items',
  templateUrl: './menu-group-items.component.html',
  styleUrls: ['./menu-group-items.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuGroupItemsComponent implements OnInit {

  @Input() store: Store;
  @Input() orderId: string;
  @Input() item: any;
  @Input() uiSetting: any;
  @Input() isCatering: boolean = false;
  @Output() itemSelected = new EventEmitter<any>();

  isVisible = true;
  descExpanded = false;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
  }

  onSelect() {
    this.itemSelected.emit(this.item);
  }

  public santize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
